import { render, staticRenderFns } from "./NewSignUp1.vue?vue&type=template&id=5480d6e0&scoped=true"
import script from "./NewSignUp1.vue?vue&type=script&lang=js"
export * from "./NewSignUp1.vue?vue&type=script&lang=js"
import style0 from "./NewSignUp1.vue?vue&type=style&index=0&id=5480d6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480d6e0",
  null
  
)

export default component.exports